import React, { useState } from "react";
import { updatePassword } from "../../../../services/settingsService";
import { toast } from "react-toastify";

const ChangePassword = ({ setPage }) => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [errors, setErrors] = useState({});

    const handleSubmit = async () => {
        setErrors({});

        // frontend validation
        if (!currentPassword || !newPassword || !confirmPassword) {
            setErrors({ general: "All fields are required." });
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrors({ confirmPassword: "Passwords do not match." });
            return;
        }

        try {
            await updatePassword({
                current_password: currentPassword,
                new_password: newPassword,
            });

            toast.success("Password updated successfully.");

            // reset + go back
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setPage("security");

        } catch (error) {
            const data = error.response?.data;

            if (data?.current_password) {
                setErrors({ currentPassword: data.current_password[0] });
                return;
            }

            if (data?.new_password) {
                setErrors({ newPassword: data.new_password[0] });
                return;
            }

            toast.error("Something went wrong. Please try again.");
        }
    };

    return (
        <div className="settings-list">

            {errors.general && (
                <small className="settings-error">
                    {errors.general}
                </small>
            )}

            {/* CURRENT PASSWORD */}
            <div className="settings-edit-item">
                <p>Current Password</p>
                <input
                    type="password"
                    value={currentPassword}
                    onChange={(e) => {
                        setCurrentPassword(e.target.value);
                        setErrors({});
                    }}
                />
                {errors.currentPassword && (
                    <small className="settings-error">
                        {errors.currentPassword}
                    </small>
                )}
            </div>

            {/* NEW PASSWORD */}
            <div className="settings-edit-item">
                <p>New Password</p>
                <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => {
                        setNewPassword(e.target.value);
                        setErrors({});
                    }}
                />
                {errors.newPassword && (
                    <small className="settings-error">
                        {errors.newPassword}
                    </small>
                )}
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="settings-edit-item">
                <p>Confirm Password</p>
                <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setErrors({});
                    }}
                />
                {errors.confirmPassword && (
                    <small className="settings-error">
                        {errors.confirmPassword}
                    </small>
                )}
            </div>

            {/* ACTIONS */}
            <div className="edit-password">
                <button
                    className="save-button"
                    onClick={handleSubmit}
                >
                    Update Password
                </button>

            </div>

        </div>
    );
};

export default ChangePassword;